// Rich, realistic mock data for Assisto 4U

export const CITIES = ["Bengaluru", "Mumbai", "Pune", "Hyderabad", "Delhi NCR", "Chennai", "Kolkata", "Ahmedabad"];

export const SKILLS = ["Accounting", "GST", "Excel", "Tally", "Finance", "Research", "Documentation", "Data Entry", "Auditing", "SQL", "Bookkeeping", "Compliance"];

export const CATEGORIES = ["Accounting & Tax", "Legal & Compliance", "Data & Research", "Documentation", "Finance", "Audit Support"];

export const tasks = [
  {
    id: "T-1042",
    title: "Quarterly GST Return Filing Support",
    company: "Meridian Textiles Pvt Ltd",
    companyId: "C-201",
    category: "Accounting & Tax",
    location: "Andheri East, Mumbai",
    coordinates: "19.1197° N, 72.8464° E",
    distance: "4.2 km",
    skills: ["GST", "Tally", "Excel"],
    education: "B.Com / M.Com",
    experience: "0-2 years",
    budget: 8500,
    deadline: "Mar 12, 2026",
    startDate: "Mar 03, 2026",
    startTime: "10:00 AM",
    workingHours: "6 hrs/day, 5 days",
    workMode: "On-site",
    status: "Open",
    posted: "2 hours ago",
    description: "Assist our finance team with GSTR-1 and GSTR-3B preparation for the March quarter. You will reconcile purchase registers, validate input tax credits and support filing on the GSTN portal under a senior accountant's supervision.",
    applications: 12,
    matchScore: 92,
  },
  {
    id: "T-1041",
    title: "Excel Dashboard for Inventory Reconciliation",
    company: "Vertex Auto Components",
    companyId: "C-198",
    category: "Data & Research",
    location: "Whitefield, Bengaluru",
    coordinates: "12.9698° N, 77.7500° E",
    distance: "6.8 km",
    skills: ["Excel", "Data Entry", "Documentation"],
    education: "Any Graduate",
    experience: "0-1 years",
    budget: 6200,
    deadline: "Mar 18, 2026",
    startDate: "Mar 05, 2026",
    startTime: "11:00 AM",
    workingHours: "4 hrs/day, flexible",
    workMode: "Hybrid",
    status: "Open",
    posted: "5 hours ago",
    description: "Build a reconciliation dashboard in Excel using pivot tables and VLOOKUPs. SKU-level variance analysis across 3 warehouses.",
    applications: 8,
    matchScore: 84,
  },
  {
    id: "T-1040",
    title: "Legal Document Review & Indexing",
    company: "Arclight Legal LLP",
    companyId: "C-172",
    category: "Legal & Compliance",
    location: "Connaught Place, Delhi",
    coordinates: "28.6315° N, 77.2167° E",
    distance: "2.1 km",
    skills: ["Documentation", "Research"],
    education: "LLB / Law Student",
    experience: "1-3 years",
    budget: 12000,
    deadline: "Mar 22, 2026",
    startDate: "Mar 08, 2026",
    startTime: "9:30 AM",
    workingHours: "8 hrs/day",
    workMode: "On-site",
    status: "Open",
    posted: "1 day ago",
    description: "Review and index 400+ contract documents. Prepare summaries with clause tagging for a due-diligence pack.",
    applications: 5,
    matchScore: 78,
  },
  {
    id: "T-1039",
    title: "Vendor Payment Reconciliation - Feb Cycle",
    company: "Kavyansh FoodWorks",
    companyId: "C-165",
    category: "Finance",
    location: "Koregaon Park, Pune",
    coordinates: "18.5362° N, 73.8958° E",
    distance: "3.5 km",
    skills: ["Accounting", "Tally", "Excel"],
    education: "B.Com",
    experience: "1-2 years",
    budget: 7400,
    deadline: "Mar 15, 2026",
    startDate: "Mar 04, 2026",
    startTime: "10:30 AM",
    workingHours: "5 hrs/day",
    workMode: "On-site",
    status: "Open",
    posted: "1 day ago",
    description: "Match vendor invoices with payment ledger, flag mismatches, prepare a reconciliation report signed off by the senior manager.",
    applications: 14,
    matchScore: 88,
  },
  {
    id: "T-1038",
    title: "Market Research - D2C Beverages Category",
    company: "Northstar Consulting",
    companyId: "C-140",
    category: "Data & Research",
    location: "Remote",
    coordinates: "—",
    distance: "Remote",
    skills: ["Research", "Excel", "Documentation"],
    education: "Any Graduate",
    experience: "0-2 years",
    budget: 15000,
    deadline: "Mar 28, 2026",
    startDate: "Mar 10, 2026",
    startTime: "Flexible",
    workingHours: "20 hrs/week",
    workMode: "Remote",
    status: "Open",
    posted: "2 days ago",
    description: "Compile competitive intelligence on 30 D2C beverage brands: pricing, positioning, distribution channels, founder profiles.",
    applications: 22,
    matchScore: 81,
  },
  {
    id: "T-1037",
    title: "Compliance Filing Assistance - ROC Forms",
    company: "Sagara Financial Services",
    companyId: "C-133",
    category: "Legal & Compliance",
    location: "BKC, Mumbai",
    coordinates: "19.0656° N, 72.8691° E",
    distance: "8.9 km",
    skills: ["Compliance", "Documentation"],
    education: "CS / Law",
    experience: "1-2 years",
    budget: 9800,
    deadline: "Mar 20, 2026",
    startDate: "Mar 06, 2026",
    startTime: "10:00 AM",
    workingHours: "6 hrs/day",
    workMode: "Hybrid",
    status: "Open",
    posted: "3 days ago",
    description: "Assist with ROC form preparation - AOC-4, MGT-7 filings for FY 24-25 close.",
    applications: 6,
    matchScore: 73,
  },
];

export const applications = [
  { id: "A-501", taskId: "T-1042", studentId: "S-9021", status: "Under Review", appliedOn: "Feb 26" },
  { id: "A-502", taskId: "T-1041", studentId: "S-9021", status: "Shortlisted", appliedOn: "Feb 25" },
  { id: "A-503", taskId: "T-1039", studentId: "S-9021", status: "Allocated", appliedOn: "Feb 22" },
];

export const candidates = [
  {
    id: "S-9021",
    name: "Ananya Ramesh",
    avatar: "https://images.unsplash.com/photo-1580489944761-15a19d654956?crop=entropy&cs=srgb&fm=jpg&w=200&h=200&fit=crop",
    education: "M.Com, Symbiosis College Pune",
    skills: ["GST", "Tally", "Excel", "Accounting"],
    distance: "3.1 km",
    rating: 4.8,
    reputation: 92,
    completionRate: 97,
    experience: "1.5 yrs",
    matchScore: 92,
    trustScore: 88,
  },
  {
    id: "S-9034",
    name: "Rohan Iyer",
    avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?crop=entropy&cs=srgb&fm=jpg&w=200&h=200&fit=crop",
    education: "B.Com (H), St. Xavier's",
    skills: ["GST", "Excel", "Bookkeeping"],
    distance: "5.6 km",
    rating: 4.6,
    reputation: 84,
    completionRate: 91,
    experience: "1 yr",
    matchScore: 86,
    trustScore: 82,
  },
  {
    id: "S-9047",
    name: "Meera Chatterjee",
    avatar: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?crop=entropy&cs=srgb&fm=jpg&w=200&h=200&fit=crop",
    education: "CA Inter, ICAI",
    skills: ["GST", "Tally", "Audit", "Compliance"],
    distance: "7.2 km",
    rating: 4.9,
    reputation: 95,
    completionRate: 99,
    experience: "2 yrs",
    matchScore: 81,
    trustScore: 91,
  },
];

export const studentStats = {
  profileCompletion: 80,
  kycStatus: "Verified",
  availableTasks: 42,
  activeTasks: 2,
  completedTasks: 17,
  rating: 4.8,
  trustScore: 88,
  earnings: 84500,
};

export const companyStats = {
  activeTasks: 6,
  pendingApproval: 2,
  applications: 47,
  allocatedTasks: 4,
  completedTasks: 23,
  totalSpend: 285400,
};

export const adminStats = {
  students: 1284,
  companies: 342,
  pendingKyc: 27,
  pendingGst: 14,
  pendingTasks: 9,
  applications: 458,
  allocations: 112,
  activeTasks: 78,
  completedTasks: 621,
};

export const workroomTimeline = [
  { id: 1, key: "allocated", label: "Allocated", ts: "Feb 22 · 11:04 AM", status: "done" },
  { id: 2, key: "checkin_open", label: "Check-in Open", ts: "Mar 04 · 9:30 AM", status: "done" },
  { id: 3, key: "checked_in", label: "Checked In", ts: "Mar 04 · 10:28 AM", status: "done" },
  { id: 4, key: "work_started", label: "Work Started", ts: "Mar 04 · 10:35 AM", status: "active" },
  { id: 5, key: "submitted", label: "Submitted", ts: "—", status: "future" },
  { id: 6, key: "approved", label: "Approved", ts: "—", status: "future" },
  { id: 7, key: "completed", label: "Completed", ts: "—", status: "future" },
];

export const chatMessages = [
  { id: 1, from: "company", name: "Meridian Textiles", text: "Welcome Ananya. Please check in from the reception before 10:15 AM.", ts: "10:04 AM" },
  { id: 2, from: "student", name: "Ananya R.", text: "Understood. I'm 5 minutes away.", ts: "10:06 AM" },
  { id: 3, from: "company", name: "Meridian Textiles", text: "Shared the purchase register on drive. Please cross-check against the March invoices.", ts: "10:32 AM", attachment: "March_Purchase_Register.xlsx" },
  { id: 4, from: "student", name: "Ananya R.", text: "Got it. Starting reconciliation now.", ts: "10:34 AM" },
];

export const submittedTasks = [
  { id: "T-1050", company: "Meridian Textiles", title: "GST Return Filing Support", location: "Mumbai", budget: 8500, deadline: "Mar 12", status: "Pending" },
  { id: "T-1051", company: "Vertex Auto", title: "Excel Reconciliation Dashboard", location: "Bengaluru", budget: 6200, deadline: "Mar 18", status: "Pending" },
  { id: "T-1052", company: "Arclight Legal", title: "Document Review & Indexing", location: "Delhi", budget: 12000, deadline: "Mar 22", status: "Pending" },
  { id: "T-1053", company: "Kavyansh FoodWorks", title: "Vendor Reconciliation", location: "Pune", budget: 7400, deadline: "Mar 15", status: "Approved" },
];
